<template>
  <details :open="isOpen">
    <summary>
      Debug
      <span v-if="props.name"
        >for <code>{{ props.name }}</code></span
      >
    </summary>
    <pre>
      {{ prefix }}<!-- linebreak removal comment
      --><i v-if="props.data === undefined">undefined</i><!-- linebreak removal comment
      --><i v-else-if="props.data === null">null</i><!-- linebreak removal comment
      --><span v-else>{{ props.data }}</span>
    </pre>
  </details>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    data: unknown
    name?: string
    open?: boolean | null
  }>(),
  {
    open: null,
  },
)

const isOpen = computed(() => props.open ?? !!props.data)

const prefix = computed(() => (props.name !== undefined ? `${props.name} = ` : ''))
</script>

<style scoped lang="scss"></style>

<script setup lang="ts"></script>
<script setup lang="ts"></script>
